var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchCategoryStorage16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/16/Storage_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Storage_16.svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B660F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CAE3E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/16/Storage_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Storage_16.svg)",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-24",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/16/Storage_16",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,7 L10.794,7 L10.794,6 L5,6 L5,7 Z M6,13 L10,13 L10,12 L6,12 L6,13 Z M11,11.5 L11,13.5 C11,13.776 10.776,14 10.5,14 L5.5,14 C5.224,14 5,13.776 5,13.5 L5,11.5 C5,11.224 5.224,11 5.5,11 L10.5,11 C10.776,11 11,11.224 11,11.5 L11,11.5 Z M14,10 L2,10 L2,14.735 C2,14.881 2.119,15 2.265,15 L13.735,15 C13.881,15 14,14.881 14,14.735 L14,10 Z M4,9 L12,9 L12,4 L9.5,4 C9.224,4 9,3.776 9,3.5 L9,1 L4,1 L4,9 Z M10,1.207 L10,3 L11.793,3 L10,1.207 Z M15,9.5 L15,14.735 C15,15.433 14.433,16 13.735,16 L2.265,16 C1.567,16 1,15.433 1,14.735 L1,9.5 C1,9.224 1.224,9 1.5,9 L3,9 L3,0.5 C3,0.224 3.224,0 3.5,0 L10,0 C10.133,0 10.26,0.053 10.354,0.146 L12.854,2.646 C12.947,2.74 13,2.867 13,3 L13,9 L14.5,9 C14.776,9 15,9.224 15,9.5 L15,9.5 Z M5,5 L8,5 L8,4 L5,4 L5,5 Z",
    id: "Storage_Category-Icon_16_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryStorage16);
export default __webpack_public_path__ + "static/media/Arch-Category_Storage_16.7b1a7dbc6d2bdb757a5c642aae2cc598.svg";
export { ForwardRef as ReactComponent };